export const DROPDOWN_WRAPPER_CONTAINER = 'dropdown-wrapper-container';
export const MODAL_ROOT_CONTAINER = 'modal-root-container';
